import React from 'react';
import { func, shape, string, arrayOf } from 'prop-types';
import { connect } from 'react-redux';
import toJS from '~/views/enhancers/toJS';
import actions from '~/state/ducks/author/actions';
import { searchAuthor } from '~/state/ducks/author/operations';
import { isFetching, getResults, getMessage } from '~/state/ducks/author/selectors';


import Search from '../components/Search';
import AuthorItem from '../components/AuthorItem';


class SearchContainer extends React.Component {

    static propTypes = {
        results: arrayOf(shape({
            id: string.isRequired,
            name: string.isRequired,
            logo_url: string.isRequired,
        })),

        setSelected: func.isRequired,
        toggleEditMode: func.isRequired,
        input: shape({
                onChange: func.isRequired,
        }).isRequired,
    }

    state = {
        value: null,
    }

    getSelectedData() {
        return this.props.results.find(({ id }) => id === this.state.value);
    }

    getOptions() {
        return this.props.results.map(({ id, name, logo_url }) => ({
            key: id,
            value: id,
            text: name,
            content: <AuthorItem small name={name} logo_url={logo_url} />,
        }));
    }

     handleSave = () => {
         console.log("handle save initial state", this.state);
         const { setAuthorId, setSelected, toggleEditMode } = this.props;
                 const authorId = this.state.value;
                 setAuthorId(authorId);
                 setSelected(this.getSelectedData());
                 toggleEditMode();
         console.log("state after changing input", this.state)
     };

    handleCancel = () => {
        this.props.toggleEditMode();
    }

    handleChange = (e, { value }) => {
        this.setState({ value });
    }

    render() {
        return (
            <Search
                {...this.props}
                options={this.getOptions()}
                isSelected={this.state.value !== null}
                handleSelect={this.handleSelect}
                handleChange={this.handleChange}
                handleCancel={this.handleCancel}
                handleSave={this.handleSave}
            />
        );
    }
}

const mapStateToProps = state => ({
    isFetching: isFetching(state),
    results: getResults(state),
    message: getMessage(state),
});

const mapDispatchToProps = {
    handleSearch: searchAuthor,
    setAuthorId: actions.setAuthorId,
    setSelected: actions.set,
    toggleEditMode: actions.editing.toggle,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(toJS(SearchContainer));
